import { ContactAttribute, ILookup, NewAccountEntityType } from 'common';
import { IContactDetailsData } from '../../../interfaces/account-registration/contact-details-data.interface';
import { IGeneralDetailsData } from '../../../interfaces/account-registration/general-details-data.interface';
import { AddressDto } from './address.dto';

export class ContactDto {
  private contactAttributes: ILookup[];

  isCompany: boolean;
  contactId: number;
  attributes: Array<AttributeDto>;
  salutation: string;
  firstname: string;
  lastname: string;
  positionHeld: string;
  phone: string;
  phoneAlternative: string;
  fax: string;
  mobilePhone: string;
  email: string;
  website: string;
  dateOfBirth: string;
  placeOfBirth: string;
  disabilityPension: boolean;
  address: AddressDto;
  licences: Array<LicenceDetailsDto>;

  set primaryContact(isPrimaryContact: boolean) {
    if (isPrimaryContact) {
      this.attributes.push(this.getContactAttributeByName(ContactAttribute.Primary));
    } else {
      this.attributes = this.attributes.filter((attribute) => attribute.attribute !== ContactAttribute.Primary);
    }
  }
  get primaryContact(): boolean {
    return (
      this.attributes.filter((attribute) => {
        attribute.attribute === ContactAttribute.Primary;
      }).length > 0
    );
  }

  constructor() {}

  fromContactDetailsData(entityType: NewAccountEntityType, contactDetailsData: IContactDetailsData, contactAttributes: ILookup[]) {
    this.contactAttributes = contactAttributes;

    this.isCompany = entityType === NewAccountEntityType.Company;
    this.contactId = -1;

    //Attributes
    this.attributes = new Array<AttributeDto>();
    contactDetailsData.attributes.value.forEach((attributeName) => {
      this.attributes.push(this.getContactAttributeByName(attributeName));
    });

    this.salutation = contactDetailsData.salutation.value;
    this.firstname = contactDetailsData.firstName.value;
    this.lastname = contactDetailsData.lastName.value;
    this.positionHeld = contactDetailsData.positionHeld.value;
    this.phone = contactDetailsData.phone.value;
    this.phoneAlternative = '';
    this.fax = '';
    this.mobilePhone = contactDetailsData.mobile.value;
    this.email = contactDetailsData.email.value;
    this.website = '';
    this.dateOfBirth = contactDetailsData.dateOfBirth.value?.toString();
    this.placeOfBirth = '';
    this.disabilityPension = false;

    //Address
    this.address = new AddressDto(
      contactDetailsData.addressLine1.value,
      contactDetailsData.addressLine2.value,
      contactDetailsData.addressLine3.value,
      contactDetailsData.addressLine4.value,
      contactDetailsData.postCode.value,
      contactDetailsData.county.value,
      contactDetailsData.country.value
    );
    this.licences = [];
  }

  primaryFromGeneralDetails(entityType: NewAccountEntityType, generalDetailsData: IGeneralDetailsData, contactAttributes: ILookup[]) {
    this.contactAttributes = contactAttributes;

    this.isCompany = entityType === NewAccountEntityType.Company;
    this.contactId = -1;

    //Attributes
    this.attributes = new Array<AttributeDto>();
    this.attributes.push(this.getContactAttributeByName(ContactAttribute.Primary));

    this.salutation = generalDetailsData.salutation.value;
    this.firstname = generalDetailsData.firstName.value;
    this.lastname = generalDetailsData.lastName.value;
    this.positionHeld = 'Primary Online Contact';
    this.phone = generalDetailsData.phone.value;
    this.phoneAlternative = '';
    this.fax = '';
    this.mobilePhone = generalDetailsData.mobile.value;
    this.email = generalDetailsData.email.value;
    this.website = '';
    this.dateOfBirth = '';
    this.placeOfBirth = '';
    this.disabilityPension = false;

    //Address
    this.address = new AddressDto(
      generalDetailsData.addressLine1.value,
      generalDetailsData.addressLine2.value,
      generalDetailsData.addressLine3.value,
      generalDetailsData.addressLine4.value,
      generalDetailsData.postCode.value,
      generalDetailsData.county.value,
      generalDetailsData.country.value
    );
    this.licences = [];
  }

  private getContactAttributeByName(attributeName: string): AttributeDto {
    var attribute: AttributeDto = null;
    var filteredList = this.contactAttributes.filter((lookup: ILookup) => {
      return lookup.value === attributeName;
    });
    if (filteredList && filteredList.length > 0) {
      attribute = new AttributeDto(filteredList[0].key, filteredList[0].value);
    }
    return attribute;
  }
}

class AttributeDto {
  attribute: string;
  displayName: string;

  constructor(attribute: string, displayName: string) {
    this.attribute = attribute;
    this.displayName = displayName;
  }
}

class LicenceDetailsDto {
  licenceAuto: string;
  licenceRef: string;
  licenceType: string;
  serviceName: string;
  status: string;
  serviceType: string;
}
